/**
 * Created by RKL on 21/08/2015.
 */
define('customersMainRouter',[
  'require',
  'exports',
  'module',
  'logger',
  'underscore',
  'marionette',
  'app',
  'customersDetailBodyContactTabs',
  'itemPagesNameMixin',
  'entities/caccounts',
  'entities/customers/customers'
], function(
  require,
  exports,
  module,
  Logger,
  _,
  Marionette,
  App,
  CustomersDetailBodyContactTabs,
  ItemPagesNameMixin,
  Accounts
) {
  'use strict';

  var CustomersRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'customers': 'showList',
      'leads': 'showLeadsList',
      'customers/code/:code(/:tab)': 'showByCode',
      'customers(/:id)(/:tab)(/:secId)(/:reload)': 'showDetail',
      'customers/:id/contacts/:secId/details/:tabName': 'showContactsDetailsShow',
      'leads/:id(/:tab)(/:secId)(/:reload)': 'showLeadDetail',
      'leads/:id/contacts/:secId/details/:tabName': 'showContactsDetailsShow'
    }
  });

  var API = {
    showByCode: function (code, tab) {
      this.customer = App.request('customers:entity:end-user-id', code);
      this.customer.fetch().done(_.bind(function (customer) {
        if (tab) {
          App.navigate('customers/' + customer.secId + '/' + tab, {trigger: true});
        } else {
          this.showDetail(customer.secId, tab ? tab : 'profile');
        }
      }, this));
    },

    showList: function () {
      require([
        'customersListController',
        'contentShowController'
      ], function (ListController, ContentShowController) {
        ContentShowController.showContent().done(function () {
          App.currentUrl = App.getCurrentRoute();
          ListController.showCustomersList();
          App.execute('set:active:nav:item', ItemPagesNameMixin.MY_CLIENTS);
        });
      });
    },

    showLeadsList: function () {
      require([
        'customersLeadsListController',
        'contentShowController'
      ], function (LeadsListController, ContentShowController) {
        ContentShowController.showContent().done(function () {
          App.currentUrl = App.getCurrentRoute();
          LeadsListController.showLeadsList();
          App.execute('set:active:nav:item', ItemPagesNameMixin.MY_LEADS);
        });
      });
    },

    showDetail: function (id, tabName) {
      this._showDetail(id, tabName, 'customers');
    },

    showLeadDetail: function (id, tabName) {
      this._showDetail(id, tabName, 'leads');
    },

    /**
     * Customers and leads share the same detail page, but each type has its own
     * base route. If the fetched end user does not match the route it was opened
     * with (e.g. a lead opened through customers/:id), redirect to the right one.
     */
    _showDetail: function (id, tabName, baseRoute) {
      require([
        'customersDetailView',
        'contentShowController'
      ], function (View, ContentShowController) {
        if(Accounts.detailView && Accounts.detailView.isDestroyed)
          Accounts.detailView = null;

        if(Accounts.detailView && Accounts.detailView.model.get('secId') !== id) {
          Accounts.detailView.destroy();
          Accounts.detailView = null;
        }
        
        var model = App.request('customers:entity', id);
        model.fetch().done(_.bind(function () {
          if (model.getRoute() !== baseRoute) {
            App.navigate(model.getRoute() + '/' + id + '/' + (tabName || 'profile'), {trigger: true});
            return;
          }

          App.request('caccount:countries').done(_.bind(function (countries) {
            
            Accounts.detailView = new View({
              model: model,
              countries: countries,
              tabName: tabName
            });

            ContentShowController.showContent().done(_.bind(function () {
              App.currentUrl = App.getCurrentRoute();
              App.regions.getRegion('main').currentView.getRegion('content').show(Accounts.detailView);
              App.execute('set:active:nav:item', model.isLead() ? ItemPagesNameMixin.MY_LEADS : ItemPagesNameMixin.MY_CLIENTS);
            }, this));
          }, this));
        }, this));        
      });
    },

    showContactsDetailsShow: function(id, contactSecId, tab) {
      require([
        'customersDetailBodyContactController',
        'contentShowController'
      ], function(
        DetailsShowController,
        ContentShowController
      ) {
        ContentShowController.showContent().done(function() {
          var data;
          data = {
            id: id,
            tab: _.findWhere(CustomersDetailBodyContactTabs, {name: tab}),
            secId: contactSecId,
            type: 'customer'
          };
           if (id) {
            DetailsShowController.fetchContact(data);
          } else {
            DetailsShowController.showContact(data);
          }
          var isLead = App.getCurrentRoute().indexOf('leads/') === 0;
          App.execute('set:active:nav:item', isLead ? ItemPagesNameMixin.MY_LEADS : ItemPagesNameMixin.MY_CLIENTS);
        });
      });
    }
  };

  App.on('customers:show', function(id, tabName) {
    if (!tabName)
      tabName = 'profile';

    App.navigate('customers/' + id + '/' + tabName, {trigger: true});
  });

  App.on('leads:show', function(id, tabName) {
    if (!tabName)
      tabName = 'profile';

    App.navigate('leads/' + id + '/' + tabName, {trigger: true});
  });

  App.on('before:start', function() {
    new CustomersRouter({
      controller: API
    });
  });

  module.exports = CustomersRouter;
});
